import { memo } from 'react';
import { useTheme } from '../../hooks/useTheme';
import {
  SkeletonCircle,
  SkeletonLine,
} from '../common/Skeleton.web';

interface MessagesListSkeletonProps {
  count?: number;
}

export const MessagesListSkeleton = memo(function MessagesListSkeleton({
  count = 7,
}: MessagesListSkeletonProps) {
  const { theme } = useTheme();

  return (
    <div
      style={{
        backgroundColor: theme.background,
        flex: 1,
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={`message-row-skeleton-${index}`}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 16px',
            borderBottom:
              index === count - 1 ? 'none' : `1px solid ${theme.border}`,
          }}
        >
          <SkeletonCircle size={48} />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <SkeletonLine width="42%" height={14} />
              <SkeletonLine width={36} height={11} />
            </div>
            <SkeletonLine width="78%" height={12} />
          </div>
        </div>
      ))}
    </div>
  );
});
